import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20sunlight%20streaming%20through%20large%20windows%20into%20a%20minimalist%20room%20with%20cream%20walls%2C%20a%20wooden%20table%20with%20a%20simple%20ceramic%20teacup%20and%20an%20open%20notebook%2C%20soft%20shadows%20and%20dust%20motes%20dancing%20in%20the%20light%2C%20peaceful%20Zen%20atmosphere%2C%20warm%20beige%20and%20cream%20tones%2C%20fine%20art%20interior%20photography%2C%20high%20detail%2C%20harmonious%20composition%2C%20no%20people&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="长日光阴 - 慢生活美学"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <p className="text-white/70 text-sm md:text-base tracking-[0.3em] mb-6 font-label animate-fade-in-up">
          珍藏每一寸慢时光
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-semibold text-white mb-8 tracking-wider leading-tight animate-fade-in-up">
          长日光阴
        </h1>
        <p className="text-white/75 text-base md:text-lg max-w-xl mx-auto leading-relaxed mb-10 animate-fade-in-up">
          用文字、影像与生活美学，帮你重新感受时间的重量，<br className="hidden sm:block" />
          找回被快节奏吞噬的从容与诗意。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up">
          <Link
            to="/category/slow-living"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始慢下来
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解我们
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
        .animate-fade-in-up:nth-child(2) { animation-delay: 0.15s; }
        .animate-fade-in-up:nth-child(3) { animation-delay: 0.3s; }
        .animate-fade-in-up:nth-child(4) { animation-delay: 0.45s; }
      `}</style>
    </section>
  );
}